import { Component, ElementRef, inject, input, signal, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { IconButtonComponent } from '@components/buttons/icon-button/icon-button.component';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { Maybe, PlayableTrailer } from '@shared/graphql/api.generated';
import { trailerSP } from '@shared/helper/responsive-sizes';
import { GeneralService } from '@shared/services/general.service';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';

@Component({
  selector: 'app-product-trailers',
  imports: [RouterLink, ImageGeneratorComponent, IconButtonComponent, MatIconModule],
  templateUrl: './product-trailers.component.html',
  styleUrls: ['./product-trailers.component.scss'],
})
export class ProductTrailersComponent {
  generalService = inject(GeneralService);

  @ViewChild('desktopSliderRef') desktopSliderRef!: ElementRef<HTMLElement>;
  Trailers = input.required<Maybe<PlayableTrailer>[]>();
  trailerSizes = trailerSP;
  desktopSlider = signal<KeenSliderInstance | undefined>(undefined);
  currentSlide = signal(0);
  showRow = signal(false);
  itemsPerView = signal(6);

  ngOnInit() {
    if (this.Trailers().length) {
      this.handleSlider();
    }
  }

  private handleSlider() {
    if (!this.generalService.isSmallScreen() && this.generalService.isBrowserOnly) {
      setTimeout(() => {
        this.desktopSlider.set(
          new KeenSlider(this.desktopSliderRef.nativeElement, {
            initial: this.currentSlide(),
            loop: false,
            rtl: true,
            renderMode: 'performance',
            drag: false,
            breakpoints: {
              '(max-width: 1920px)': {
                slides: {
                  perView: 5,
                  spacing: 20,
                },
              },
              '(max-width: 1440px)': {
                slides: {
                  perView: 5,
                  spacing: 8,
                },
              },
              '(max-width: 1200px)': {
                slides: {
                  perView: 4,
                  spacing: 12,
                },
              },
              '(max-width: 992px)': {
                slides: {
                  perView: 3,
                  spacing: 12,
                },
              },
            },
            slides: {
              perView: 6,
              spacing: 20,
            },
            slideChanged: (s) => {
              this.currentSlide.set(s.track.details.rel);
            },
            created: () => {
              this.showRow.set(true);
              const width = window.innerWidth;
              if (width <= 1920 && width > 1200) {
                this.itemsPerView.set(5);
              } else if (width <= 1200 && width > 992) {
                this.itemsPerView.set(4);
              } else if (width <= 992 && width > 768) {
                this.itemsPerView.set(3);
              }
            },
          }),
        );
      });
    } else {
      this.showRow.set(true);
    }
  }

  nextSlide() {
    this.desktopSlider()?.next();
    // this.desktopSlider()?.moveToIdx(this.currentSlide + this.desktopSlider()?.track.details.maxIdx);
  }

  prevSlide() {
    this.desktopSlider()?.prev();
    // this.desktopSlider()?.moveToIdx(this.currentSlide - this.desktopSlider()?.track.details.maxIdx);
  }
}
